window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBZ9BeW_DnVp_5UDoB9tq6xGcCSgvPPSvc',
        libraries: 'places',
        region: 'NL',
        language: 'nl'
    }
});

import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css';

Vue.use(Toaster, {timeout: 4000});

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);

import VShowSlide from 'v-show-slide';
Vue.use(VShowSlide);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
Vue.use(PerfectScrollbar, { options: { 'wheelPropagation': false } });

import VueMq from 'vue-mq';
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        mobile: 768,
        tablet: 1024,
        laptop: 1250,
        desktop: Infinity,
    }
})

Vue.component('pp-parts-point-finder', require('../../../../../modules/custom/partspoint_base/js/components/PartsPointFinder').default);
Vue.component('pp-youtube-wrapper', require('../vue/components/YoutubeWrapper').default);
Vue.component('pp-accordion', require('../vue/components/Accordion').default);
Vue.component('ef2-accordion', require('../vue/components/AccordionServices').default);

new Vue({
    'el': '#page-wrapper',

    comments: true,
});